import "./index.css";
import { Clock } from "./Clock";
import { AdminPanel } from "./AdminPanel";
import { WSClient } from "./ws-client";

const protocol = window.location.protocol === "https:" ? "wss" : "ws";
const port = protocol === "ws" ? ":3000" : "";
const ws = new WSClient(`${protocol}://${window.location.hostname}${port}/ws`);

export function App() {
  const isAdmin = window.location.pathname === "/admin";

  return (
    <div className="app">
      {isAdmin ? <AdminPanel ws={ws} /> : <Clock ws={ws} />}
    </div>
  );
}

export default App;
